// Needs to be in its own file because it would create a strange error in the firebase.ts file otherwise
export enum ResourceInventoryEditMode {
    ABSOLUTE = "ABSOLUTE",
    RELATIVE = "RELATIVE",
}
